<template>
  <div class="book">
    <div class="container btnP searchDV text-center pt-2">
      <button class="btn btn-info btnP" @click="prt()">طباعة</button>
    </div>

    <div class="page1" v-for="itm in lng" :key="itm">
      <div class="subpage">
        <header class="row">
          <div class="col-4 pt-4">
            شركة الصافنات للنقل
          </div>
          <div class="col-4">
            <p class="text-center">بسم الله الرحمن الرحيم</p>
            <p class="text-center">تقرير الحافلات</p>
          </div>
          <div class="col-4 text-left">
            <img src="../../../public/static/img/logo.png" alt="" />
          </div>
        </header>
        <div class="bd">
          <table class="table">
            <thead>
              <tr>
                <th>م</th>
                <th>كود الحافلة</th>
                <th>ماركة الحافلة</th>
                <th>موديل الحافلة</th>
                <th>عدد المقاعد</th>
                <th>بداية الترخيص</th>
                <th>نهاية الترخيص</th>
                <th>تاريخ التصنيع</th>
                <th>السائق</th>
                <th>خط السير من</th>
                <th>خط السير الى </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rw  in cunt" :key="rw">
                <td>{{ inx }}</td>
                <td>{{ load[indx].id }}</td>
                <td>{{ load[indx].boardNum }}</td>
                <td>{{ load[indx].busName }}</td>
                <td>{{ load[indx].busModel }}</td>
                <td>{{ load[indx].busSeats }}</td>
                <td>{{ load[indx].lcStart }}</td>
                <td>{{ load[indx].lcEnd }}</td>
                <td>{{ load[indx].fullName }}</td>
                <td>{{ load[indx].areaName }} </td>
                <td>{{ load[indx].toName }} </td>

                {{
                  addnum(indx, itm)
                }}
              </tr>
            </tbody>
          </table>
        </div>
        <footer class="row">
          <div class="col-4">
            <span>رقم الصفحة </span>
            <span>{{ itm }}</span>
            <span> | </span>
            <span> {{ lng }} </span>
          </div>
          <div class="col-4 "></div>
          <div class="col-4">
            <span>التاريخ</span>
            <span> / </span>
            <span>{{ dt }} </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import reportsLayout from "../../layouts/reportsLayout.vue";

export default {
  name: "studentR",
  data() {
    return {
      lng: 0,
      datalng: 0,
      cunt: 10,
      indx: 0,
      kwd: 0,
      dt: "",
      inx:1,
    };
  },
  props: ["load"],
  computed: {
    // ...mapGetters({
    //   load: "stdMod/GET_STDALL",
    // }),
  },
  created() {
    this.$emit("update:layout", reportsLayout);
    this.reportLoad();
    this.loadDate();
  },
  methods: {
    addnum: function(indx, itm) {
      //   var ss = this.load[indx].id;
      //   console.log(indx);
      //   console.log(ss);
      this.inx += 1; 
      this.indx = this.indx - 1;
      if (itm == this.lng) {
        if (this.kwd > 1) {
          if (this.indx == this.kwd - 1) {
            this.cunt = this.indx;
          }
        } else if (this.kwd == 1) {
          if (this.indx == 1) {
            this.cunt = 1;
          }
        }
      }
    },
    reportLoad() {
      if (this.load != null) {
        this.indx = this.load.length - 1;
        var lln = Math.floor(this.load.length / this.cunt);
        if (lln < 1) {
          this.cunt = this.load.length;
          this.lng = 1;
        } else {
          this.lng = Math.ceil(this.load.length / this.cunt);
          var ss = this.cunt * lln;
          this.kwd = this.load.length - ss;
        }

        //window.print();
      }
    },
    prt() {
      window.print();
    },
    loadDate() {
      const event = new Date();
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      this.dt = event.toLocaleDateString("ar-SA", options);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../public/static/css/print.css";
.searchDV {
  height: 50px;
  width: 790px;
  background-color: white;
}
.bd {
  height: 940px;
}
thead {
  background-color: #d4d4d4;
}
</style>
